import PageMobile from "./PageMobile";

export default PageMobile;
